import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllOteFpas } from "../api/getAllOteFpas";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useOteFpasDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetOteFpa []>([]);
  const getAllOteFpasQuery = useGetAllOteFpas({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllOteFpasQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllOteFpasQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllOteFpasQuery.data ? getAllOteFpasQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Κατηγορία ΦΠΑ",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Κατηγορίας ΦΠΑ");
        break;
      case "edit":
        title = t("Επεξεργασία Κατηγορίας ΦΠΑ");
        break
        case "delete":
        title = t("Διαγραφή Κατηγορίας ΦΠΑ");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllOteFpasQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
